import { computed, makeObservable } from 'mobx';
import { SelectInputComponent, SelectInputState } from '../../components/input/input.select';
import { IMithrilStateComponent } from '../../components/mithril.component';
import { Spinner } from '../../components/spinner/spinner';
import { T, Translate } from '../../i18n';
import { m, type MithrilVNode } from '../../mithril';
import { CurrentState } from '../../state/page.state';
import { CSS } from './collection.status.modal.style';
import { StatusSelectorCtrl } from './status.selector.ctrl';

export class StatusSelector extends IMithrilStateComponent {
	ctrl: StatusSelectorCtrl;
	inputState: SelectInputState;

	constructor() {
		super();

		makeObservable(this);

		this.ctrl = new StatusSelectorCtrl();
		this.inputState = new SelectInputState(T.STATUS);
		this.inputState.isRequired = false;

		this.reaction(
			() => this.inputState.value,
			(status) => this.ctrl.selectStatus(status),
			{ fireImmediately: true }
		);
		this.reaction(
			() => this.ctrl.statusOptions,
			(options) => {
				this.inputState.setOptions(options);
				this.inputState.setValue(null);
			},
			{ fireImmediately: true }
		);
	}

	get nodes(): MithrilVNode {
		if (this.inputState == null) {
			return null;
		}

		if (this.ctrl.loadingStatuses) {
			return Spinner.view();
		}

		return SelectInputComponent.view(this.inputState);
	}

	selectedStats(): MithrilVNode {
		if (!this.ctrl.selectedStatus) {
			return null;
		}

		let count = 0;
		for (const stats of this.ctrl.allStatuses) {
			if (stats.statuses.indexOf(this.selectedStatus) > -1) {
				count++;
			}
		}

		return m('ul', { className: CSS.list }, [
			m('li', this.selectedStatus + ': ' + count),
			m('li', Translate(T.COLLECTION_STATUS_CANNOT_CHANGE, { count: CurrentState.Tag.collections.length - count })),
		]);
	}

	@computed get selectedStatus(): string {
		return this.ctrl.selectedStatus;
	}
}
